module.exports = __webpack_public_path__ + "dist/logo_dark_444_120.bd8b28cd.png";